import {actions} from "./Reducer"


export const getMySupplierPrivateInquiryAction = (payload) => ({
    type : actions.GET_MY_SUPPLIER_PRIVATE_INQUIREY,
    payload 
})

export const getMySupplierPrivateInquirySuccessAction = (privateInquiry) => ({
    type : actions.GET_MY_SUPPLIER_PRIVATE_INQUIREY_SUCCESS , 
    payload : privateInquiry
})


export const getMySupplierPrivateInquiriesAction = (body) => ({
    type:actions.GET_MY_SUPPLIER_PRIVATE_INQUIRIES,
    payload: body
})

export const getMySupplierPrivateInquiriesSuccessAction = (inquiries) => ({
    type: actions.GET_MY_SUPPLIER_PRIVATE_INQUIRIES_SUCCESS,
    payload: inquiries
})


export const addProposalBySupplierAction = (body, trusted) => ({
    type: actions.ADD_PROSPOSAL_BY_SUPPLIER,
    payload: body,
    trusted
})

export const addProposalBySupplierSuccessAction = (proposal) => ({
    type: actions.ADD_PROSPOSAL_BY_SUPPLIER_SUCCESS,
    payload: proposal
})

export const setMySupplierPrivateInquiryIsLoading = (isLoading) => ({
    type : actions.MY_SUPPLIER_PRIVATE_INQUIREY_IS_LOADING,
    payload : isLoading
})

export const setMySupplierPrivateInquiryCountAction = (value) => ({
    type: actions.SET_MY_SUPPLIER_PRIVATE_INQUIRIES_COUNT,
    payload: value
})

export const getMySupplierProposalsAction = (body) => ({
    type:actions.GET_MY_SUPPLIER_PROPOSALS,
    payload: body
})

export const getMySupplierProposalsSucessAction = (proposals) => ({
    type: actions.GET_MY_SUPPLIER_PROPOSALS_SUCCESS,
    payload: proposals
})

export const getMySupplierProposalAction = (body) => ({
    type:actions.GET_MY_SUPPLIER_PROPOSAL,
    payload: body
})

export const getMySupplierProposalSuccessAction = (proposal) => ({
    type: actions.GET_MY_SUPPLIER_PROPOSAL_SUCCESS,
    payload: proposal
})

export const editProposalBySupplierAction = (body, trusted) => ({
    type:actions.EDIT_PROPOSAL_BY_SUPPLIER,
    payload: body,
    trusted
})

export const editProposalBySupplierSuccessAction = (proposal) => ({
    type:actions.EDIT_PROPOSAL_BY_SUPPLIER_SUCCESS,
    payload: proposal
})
